if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector(
        '.js-results-container'
      );
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector(
        '.js-message-error'
      );
      this.errorMessageText =
        this.errorMessageContainer.querySelector('[data-text]');
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      var searchDrawerContent = document.querySelector('.drawer__content--search');
      var searchSuggestions = document.querySelector('.search-drawer__suggestions');

      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            if(window.innerWidth < 990) {
              searchDrawerContent.style.height = 'auto';
            }
            if(searchSuggestions) {
              searchSuggestions.style.display = 'block';
            }
            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);
          if(window.innerWidth <= 990) {
            searchDrawerContent.style.height = '100%';
          }
          if(searchSuggestions) {
            searchSuggestions.style.display = 'none';
          }
        }, 300);
      });

      this.input.addEventListener('keydown', e => {
        const isEscape = e.key === 'Escape';

        if (!isEscape) {
          return;
        }

        if (!this.input.value) {
          if (this.drawer) {
            this.drawer.parentElement.parentElement.toggleDrawer();
          }

          return;
        }

        this.close();
      });

      this.btnClearText.addEventListener('click', e => {
        this.close();
        searchDrawerContent.style.height = 'auto';
        if(searchSuggestions) {
          searchSuggestions.style.display = 'block';
        }
      });
    }

    async getSearchResults(searchTerm) {
      try {
        const response = await fetch(
          `${Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=product,page,article,collection,query&resources[limit]=8&section_id=predictive-search`
        );

        if (!this.isOpen) {
          return;
        }

        if (!response.ok) {
          const error = new Error(response.status);

          throw error;
        }

        const text = await response.text();
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector(
            '#shopify-section-predictive-search'
          ).innerHTML;

        this.resultsContainer.innerHTML = resultsMarkup;
        this.open();

        // ⬇️ AGGIUNGI QUI la chiamata per le frecce
   // Attendi che il DOM sia davvero aggiornato prima di inserire le frecce
requestAnimationFrame(() => {
  const gridReady = () => {
    if (document.querySelector('.predictive-search__grid')) {
      console.log('[Predictive Search] Grid found after DOM update, setting up arrows...');
      setupPredictiveSliderArrows();
      return true;
    }
    return false;
  };

  if (!gridReady()) {
    const observer = new MutationObserver(() => {
      if (gridReady()) {
        observer.disconnect();
      }
    });
    observer.observe(this.resultsContainer, { childList: true, subtree: true });
  }
});



        // new added product cards - quick cart triggers - set event listeners
        document.querySelector('quick-cart-drawer')?.initTriggers();

      } catch (error) {
        this.errorMessageText.textContent = error.message;
        this.errorMessageContainer.classList.remove('hidden');
      }
    }

    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.btnSubmit.setAttribute('tabindex', '-1');
      this.btnClearText.removeAttribute('disabled');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.focus();
      this.btnSubmit.removeAttribute('tabindex');
      this.btnClearText.setAttribute('disabled', true);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}



function setupPredictiveSliderArrows() {
  const grid = document.querySelector('.predictive-search__grid-wrapper');
  const wrapper = document.querySelector('.predictive-search__slider-container');

  if (!grid || !wrapper) return;

  let leftArrow = document.querySelector('.predictive-search__slider-arrow.left');
  let rightArrow = document.querySelector('.predictive-search__slider-arrow.right');

  if (!leftArrow || !rightArrow) {
    leftArrow = document.createElement('button');
    leftArrow.className = 'predictive-search__slider-arrow left';
    leftArrow.setAttribute('aria-label', 'Scorri a sinistra');
    leftArrow.innerHTML = '&#10094;';

    rightArrow = document.createElement('button');
    rightArrow.className = 'predictive-search__slider-arrow right';
    rightArrow.setAttribute('aria-label', 'Scorri a destra');
    rightArrow.innerHTML = '&#10095;';

    wrapper.appendChild(leftArrow);
    wrapper.appendChild(rightArrow);
  }

  const updateArrowsState = () => {
    const scrollLeft = grid.scrollLeft;
    const maxScrollLeft = grid.scrollWidth - grid.clientWidth;

    leftArrow.disabled = scrollLeft <= 0;
    rightArrow.disabled = scrollLeft >= maxScrollLeft - 1;
  };

  leftArrow.onclick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    grid.scrollBy({ left: -300, behavior: 'smooth' });
  };

  rightArrow.onclick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    grid.scrollBy({ left: 300, behavior: 'smooth' });
  };

  grid.addEventListener('scroll', updateArrowsState);
  updateArrowsState();
}




 
   
 
